export default __webpack_public_path__ + "static/mobcase2-16a64e1ea3a81d17b78789002ebceb7e.png";